window.Edocat = window.Edocat || {};

if (process.env.NODE_ENV === 'production') {
  window.Edocat.versions = window.Edocat.versions || {};
  window.Edocat.versions.REACT_BASE = APP_VERSION;
}

if (!window.HashChangeEvent) {
  require('./Components/Router/utils/hashChangePolyfill');
}

// Config
const messages = window.Alfresco?.messages || window.parent?.Alfresco?.messages;
if (messages) {
  window.Edocat.Config = window.Edocat.Config || {};

  window.Edocat.Config.dateFormat =
    messages.global['edocat.override.js-config.date-format'] || messages.global['edocat.js-config.date-format'];
  window.Edocat.Config.timeFormat =
    messages.global['edocat.override.js-config.time-format'] || messages.global['edocat.js-config.time-format'];
  window.Edocat.Config.dateTimeFormat =
    messages.global['edocat.override.js-config.date-time-format'] ||
    messages.global['edocat.js-config.date-time-format'];
}

// Ext actions to communicate between react apps
window.Edocat.extActions = {};

// Shared data to share data between react apps
window.Edocat.SharedData = {};

// Components
window.Edocat.Components = {};

window.React = require('react');
window.reactDOM = require('@hot-loader/react-dom');
window.reactRedux = require('react-redux');
window.redux = require('redux');
window.reduxThunk = require('redux-thunk').default;
window.Material = require('@material-ui/core');
window.labMaterial = require('@material-ui/lab');
window.MaterialIcons = require('@material-ui/icons');
window.dnd = require('react-beautiful-dnd');

window.moment = require('moment');
window.Edocat.Utils = require('./utils');

window.promiseMiddleware = require('redux-promise-middleware').default;
window.promisePolyfill = require('promise-polyfill');

window.Edocat.Components.Editor = require('./Components/Editor/Editor').default;
window.Edocat.Components.Modal = require('./Components/Modal').default; // TODO:  Old modal - replace with ModalTest
window.Edocat.Components.ModalTest = require('./Components/ModalTest');
window.Edocat.Components.Router = require('./Components/Router');
window.Edocat.Components.Select = require('./Components/Select');
window.Edocat.Components.Preview = require('./Components/Preview').default;
window.Edocat.Components.Datepicker = require('./Components/DatePicker').default;
window.Edocat.Components.Button = require('./Components/Button').default;
window.Edocat.Components.AvatarE = require('./Components/AvatarE').default;
window.Edocat.Components.CheckBox = require('./Components/CheckBox').default;
window.Edocat.Components.TextField = require('./Components/TextField').default;
window.Edocat.Components.Form = require('./Components/Form').default;
window.Edocat.Components.Loader = require('./Components/Loader').default;
window.Edocat.Components.Switcher = require('./Components/Switch').default;
window.Edocat.Components.Table = require('./Components/Table/components/Table').default;
window.Edocat.Components.TableButton = require('./Components/Table/components/TableButton/TableButton').default;
window.Edocat.Components.PathPicker = require('./Components/PathPicker');
window.Edocat.Components.Upload = require('./Components/Upload');

window.ReactPagination = require('react-paginate').default; // replace with mui

import './Styles/Global.scss';
